import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "trigger", "thankYou"]

  open(event) {
    event.preventDefault()
    this.formTarget.classList.remove("hidden")
    this.triggerTarget.classList.add("-is-active")
  }

  close(event) {
    event.preventDefault()
    this.formTarget.classList.add("hidden")
    this.triggerTarget.classList.remove("-is-active")
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.formTarget.classList.add("hidden")
      this.triggerTarget.classList.remove("-is-active")
    }
  }

  submit(event) {
    event.preventDefault()
    const form = event.target
    const message = form.querySelector('textarea[name="feedback"]').value
    if (!message) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({
        email: form.querySelector('input[name="email"]').value,
        msg: message,
      }),
    }).then((response) => {
      if (response.ok) {
        this.formTarget.classList.add("hidden")
        this.triggerTarget.classList.remove("-is-active")
        this.thankYouTarget.classList.remove("hidden")
      }
    })
  }

  connect() {
    this._clickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this._clickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._clickOutside)
  }
}
